<template>
  <div class="register vh-100 pl-3 pr-3 d-flex justify-content-center align-items-center">
    <div class="container mt-5">
      <div class="row flex-column-reverse flex-sm-row">
        <div class="col-sm-6 p-5 text-center d-flex flex-column align-items-center justify-content-center">
          <h1 class="title text-white">Meld je aan</h1>
          <div class="sub-title text-white">
            Wil je ook gratis gebruiken? Schrijf je in en begin vandaag nog met de financiën van je onderneming.
          </div>

          <a
              class="btn-subscribe"
              target="_blank"
              href="https://app.simplefinance.nl/?register=true"
          >
            Inschrijven
          </a>
        </div>
        <div class="d-none d-sm-flex col-sm-3 justify-content-center align-items-center">
          <img
              src="../../assets/img/screenshots/register-2-login.png"
              class="img-screenshot img-screenshot-portrait screenshot img-shadow"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-once="false"
          />
        </div>
        <div class="d-none d-sm-flex col-sm-3 justify-content-center align-items-center">
          <img
              src="../../assets/img/screenshots/register-1-registration-form.png"
              class="img-screenshot img-screenshot-portrait screenshot img-shadow"
              data-aos="fade-down"
              data-aos-duration="1000"
              data-aos-once="false"
          />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Register'
};
</script>

<style scoped>
.register {
  min-height: 950px;
  background: #008fff;
  background: linear-gradient(112deg, #B24592, #F15F79);
  background-size: 120% 120%;
  animation: animatedbg 12s ease infinite;
}

.btn-subscribe {
  background-color: white;
  color: #D25F94;
  font-size: 10pt;
  text-decoration: none;
  padding:  20px 45px;
  margin-top: 40px;
  transition: .3s;
}

.btn-subscribe:hover {
  background-color: #D8D8D8;
}
</style>
